import React, { useCallback, useEffect, useState } from "react";
import Table from "../components/Table";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { apiKey } from "../config/config";
import { convertDateFormat } from "../services/helper";
import { toast } from "react-toastify";

export default function Customer({ lang }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;
  const branchId = JSON.parse(
    JSON.parse(sessionStorage.getItem("aman-admin"))?.admin
  )?.branch_id;

  const [customer, setCustomer] = useState([]);
  const [customerToDelete, setCustomerToDelete] = useState();
  // const [customerID, setCustomerID] = useState();
  // const [verifyCustomer, setVerifyCustomer] = useState();

  const isLighMode =
    JSON.parse(
      JSON.parse(sessionStorage.getItem("aman-admin") || "")?.admin || ""
    )?.light_mode === "yes";

  const navigate = useNavigate();

  const returnTable = async (table) => {
    await setCustomerToDelete(table.map((item) => item.original.id));
  };

  const fetchCustomer = useCallback(() => {
    try {
      axios
        .get(apiKey + "/get-customers", {
          params: {
            branch_id: branchId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setCustomer(res.data.result);
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (err) {
      console.error(err);
    }
  }, [branchId, token]);

  const columns = [
    {
      header: "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: lang.Customer_Name || "Customer Name",
      accessorKey: "FullName",
    },
    {
      header: lang.Identity_Number || "Identity Number",
      accessorKey: "ValidNationalID",
    },
    {
      header: lang.Occupation || "Occupation",
      accessorKey: "Occupation",
    },
    {
      header: lang.Mobile_Number || "Mobile Number",
      accessorKey: "MobilePhoneNo",
    },
    {
      id: "Status",
      header: lang.Status || "Status",
      cell: (row) => {
        const status = row.row.original.contracts[0]?.contract_status;
        return parseInt(status) === 1 ? (
          <span className="badge rounded-pill bg-success">
            {lang.active || "Active"}
          </span>
        ) : parseInt(status) === 2 ? (
          <span className="badge rounded-pill bg-primary">
            {lang.completed || "Completed"}
          </span>
        ) : parseInt(status) === 3 ? (
          <span className="badge rounded-pill bg-danger">
            {lang.defaulted || "Defaulted"}
          </span>
        ) : (
          <span className="badge rounded-pill bg-warning">
            {lang.no_contract || "No Contract"}
          </span>
        );
      },
      // 👇 This tells TanStack how to filter
      filterFn: (row, columnId, filterValue) => {
        if (!filterValue) return true;

        const contracts = row.original.contracts || [];
        const status = contracts[0]?.contract_status;

        // If user selects "No Contract"
        if (Number(filterValue) === 0) {
          return contracts.length === 0 || status == null;
        }

        return Number(status) === Number(filterValue);
      },
      meta: {
        filterOptions: [
          { label: lang.active || "Active", value: 1 },
          { label: lang.completed || "Completed", value: 2 },
          { label: lang.defaulted || "Defaulted", value: 3 },
          { label: lang.no_contract || "No Contract", value: 0 },
        ],
      },
    },
    {
      header: lang["Start Date"] || "Start Date",
      cell: (row) =>
        row.row.original.contracts[0]?.date_contract &&
        convertDateFormat(row.row.original.contracts[0]?.date_contract),
    },
    {
      header: lang["Due Date"] || "Due Date",
      cell: (row) =>
        row.row.original.contracts[0]?.date_1st_installment &&
        convertDateFormat(row.row.original.contracts[0]?.date_1st_installment),
    },
    // {
    //   header: lang.Note || "Note",
    //   cell: row => row.row.original.contracts[0]?.customer_note
    // },
    {
      header: lang.Actions || "Actions",
      cell: (row) => (
        <div className="dropdown top-0 start-0">
          <button
            className="btn btn-primary dropdown-toggle"
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {lang.Actions || "Actions"}
          </button>
          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li>
              <button
                className="dropdown-item mt-0"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("profile/customer/" + row.row.original.customer_id);
                }}
              >
                {lang.Profile || "Profile"}
              </button>
            </li>
            <li>
              <button
                className="dropdown-item mt-0"
                disabled={
                  !(
                    row.row.original.contracts[0] &&
                    row.row.original.contracts[0].contract_status
                  )
                    ? true
                    : false
                }
                onClick={(e) => {
                  e.preventDefault();
                  navigate("contracts/" + row.row.original.customer_id);
                }}
              >
                {lang.Contracts || "Contracts"}
              </button>
            </li>
            <li>
              <button
                className="dropdown-item mt-0"
                onClick={() => {
                  let phoneNo = row.row.original.MobilePhoneNo.toString();
                  let waNum = "+966" + phoneNo.slice(1);
                  window.open("https://wa.me/" + waNum, "_blank");
                }}
              >
                {lang.whatsapp || "WhatsApp"}
              </button>
            </li>
            <li>
              <button
                className="dropdown-item mt-0"
                onClick={() => {
                  const formData = {
                    customer: row.row.original.customer_id,
                  };
                  if (!isLighMode) {
                    sessionStorage.setItem(
                      "formData",
                      JSON.stringify(formData)
                    );
                    navigate("/dashboard/contracts/identification");
                  } else {
                    navigate(
                      `/lightmode/dashboard/contracts/future/light-contract?${new URLSearchParams(
                        formData
                      ).toString()}`
                    );
                  }
                }}
              >
                {lang.create_contract || "Create Contract"}
              </button>
            </li>
            {row.row.original?.contracts?.length === 0 && (
              <li>
                <button
                  onClick={() => handleDelete(row.row.original.customer_id)}
                  className="dropdown-item mt-0"
                >
                  {lang.Delete_Text || "Delete"}
                </button>
              </li>
            )}
          </ul>
        </div>
      ),
    },
  ];

  const handleDelete = (id) => {
    axios
      .delete(`${apiKey}/delete-single-user/customer/${branchId}/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        fetchCustomer();
        toast.success(res.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        toast.error(err.response.data.message || "Some Error Occured", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  useEffect(() => {
    if (branchId) {
      fetchCustomer();
    }
  }, [branchId, fetchCustomer]);

  useEffect(() => {
    if (customerToDelete) {
      console.log(customerToDelete);
      try {
        axios
          .put(
            apiKey + "/delete-user/customer",
            {
              idList: customerToDelete,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((res) => {
            console.log(res.data.Message);
            fetchCustomer();
          })
          .catch((err) => {
            console.error("error");
          });
      } catch (err) {
        console.error(err);
      }
    }
  }, [customerToDelete, fetchCustomer, token]);

  return (
    <div>
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>{lang.Customer_Management || "Customer Management"}</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                >
                  <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
                </svg>
              </li>
              <li className="breadcrumb-item">
                {lang.Customer_Management || "Customer Management"}
              </li>
              <li className="breadcrumb-item active">
                {lang.Customer_List || "Customer List"}
              </li>
            </ol>
          </nav>
        </div>

        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="row justify-content-end w-100">
                  <div className="col-md-4 col-lg-3 mt-4">
                    <Link
                      to={
                        !isLighMode ? "add-customer" : "add-lightmode-customer"
                      }
                    >
                      <button type="button" className="btn btn-primary">
                        <img
                          src="img/fi_plus.png"
                          alt=""
                          className="img-fluid"
                        />
                        {lang.Add_New_Customer || "Add New Customer"}
                      </button>
                    </Link>
                  </div>
                </div>

                <div className="row pt-3">
                  <div className="rr col-9">
                    {lang.Customer_List || "Customer List"}
                  </div>
                </div>
                <div className="card-body">
                  <div classNames="d-flex mt-3 mb-3">
                    <Table
                      lang={lang}
                      data={customer}
                      columns={columns}
                      returnTable={returnTable}
                      colFilter={[lang.Status || "Status"]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

